module.exports = require("/Applications/MAMP/htdocs/gatsby-tuts/first-site/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 676
// module chunks = 231608221292675